<div class="cookies-info" *ngIf="showCookiesBanner">
  <div class="cookies-info-close" (click)="agreedCookies()">OK</div>
  <span
    class="cookies-info-text"
    [innerHTML]="'html.cookies_info' | transloco"
  ></span>
</div>
